import { createApp } from 'vue'
import App from '@/App.vue'
import { registerPlugins } from '@core/utils/plugins'
import { VueReCaptcha } from 'vue-recaptcha-v3'

// Styles
import '@core/scss/template/index.scss'
import '@styles/styles.scss'

// Create vue app
const app = createApp(App)

// Register plugins
registerPlugins(app)

if (import.meta.env.VITE_RECAPTCHA_SITE_KEY) {
  app.use(VueReCaptcha, {
    siteKey: import.meta.env.VITE_RECAPTCHA_SITE_KEY,
  })
}

// Mount vue app
app.mount('#app')
